export const DOWNLOAD_URL =
  "https://kyros-launcher-enterprise-929633566631.s3.eu-south-1.amazonaws.com/installer/KyrosSetup.exe";

export const DISCORD_URL = "https://discord.gg/sFxWsn4ruU";

export const games = [
  {
    id: "zombie-crushers",
    name: "Zombie Crushers",
    slug: "zombie-crushers",
    route: "/games/zombie-crushers",
    legacyRoute: "/zombie-crushers",
    status: "Disponibile",
    platform: "Windows",
    storeStatus: "Gratis",
    leaderboardStatus: "Classifica attiva",
    primaryCta: "Gioca gratis",
    secondaryCta: "Vedi classifica",
    image: "/images/zombie_crushers_carousel_2880x960.webp",
    cover: "/images/zombie_crushers_carousel_1600x1400.webp",
    summary:
      "Survival horror arcade gratuito. Si scarica dal launcher Kyros e ha una classifica pubblica per confrontare le run."
  },
  {
    id: "warfront",
    name: "WarFront",
    slug: "warfront",
    route: "/games/warfront",
    legacyRoute: "/warfront",
    status: "Scheda pronta",
    platform: "Windows",
    storeStatus: "Acquisto dallo Store",
    leaderboardStatus: "Nessuna classifica prevista",
    primaryCta: "Vai allo Store",
    secondaryCta: "Leggi la scheda",
    image: "/images/warfront_background.jpg",
    cover: "/images/warfront_background.jpg",
    summary:
      "FPS tattico autoprodotto per Windows. Prima dell'acquisto trovi scheda, requisiti, licenza e supporto."
  },
  {
    id: "ghost-hunter",
    name: "Ghost Hunter",
    slug: "ghost-hunter",
    route: "/games/ghost-hunter",
    legacyRoute: "/ghosthunter",
    status: "In sviluppo",
    platform: "Windows / playtest",
    storeStatus: "Non in vendita",
    leaderboardStatus: "In arrivo con i playtest",
    primaryCta: "Segui i test",
    secondaryCta: "Guarda teaser",
    image: "/images/ghost_hunter_carousel_2880x960.webp",
    cover: "/images/ghost_hunter_carousel_1600x1400.webp",
    summary:
      "Caccia al soprannaturale autoprodotta da Kyros e ancora in sviluppo. Puoi seguirla nei playtest, ma non è un gioco in vendita."
  }
];

export const primaryNavItems = [
  { label: "Home", to: "/", end: true },
  { label: "Giochi", to: "/games" },
  { label: "Store", to: "/store" },
  { label: "Account", to: "/account" },
  { label: "Contatti", to: "/contact" }
];

export const siteSearchEntries = [
  {
    id: "home",
    title: "Home",
    description: "I giochi Kyros per Windows: cosa puoi scaricare, comprare o seguire mentre è in sviluppo.",
    to: "/",
    type: "Pagina",
    keywords: ["home", "kyros", "giochi", "launcher", "store", "autoprodotti", "piattaforma"]
  },
  {
    id: "games",
    title: "Giochi",
    description: "Tutti i giochi Kyros: Zombie Crushers, WarFront e Ghost Hunter.",
    to: "/games",
    type: "Pagina",
    keywords: ["games", "giochi", "catalogo", "zombie", "warfront", "ghost", "autoprodotti"]
  },
  {
    id: "store",
    title: "Store",
    description: "Acquista WarFront o aggiungi giochi gratuiti alla libreria Kyros.",
    to: "/store",
    type: "Store",
    keywords: ["store", "negozio", "acquisto", "stripe", "libreria", "warfront"]
  },
  {
    id: "account",
    title: "Account",
    description: "Accedi, controlla la libreria e collega i giochi al launcher.",
    to: "/account",
    type: "Account",
    keywords: ["account", "login", "libreria", "launcher", "licenza"]
  },
  {
    id: "contact",
    title: "Contatti",
    description: "Supporto per giochi Kyros, launcher, account, Store, stampa e contenuti.",
    to: "/contact",
    type: "Supporto",
    keywords: ["contatti", "contact", "supporto", "launcher", "stampa", "contenuti"]
  },
  {
    id: "platform",
    title: "Piattaforma Kyros",
    description: "Come Kyros sviluppa e distribuisce i propri videogame con Store, account e launcher.",
    to: "/services",
    type: "Pagina",
    keywords: ["piattaforma", "autoprodotti", "store", "launcher", "account"]
  },
  {
    id: "privacy",
    title: "Privacy",
    description: "Come richiedere informazioni sui dati del tuo account Kyros.",
    to: "/privacy",
    type: "Legal",
    keywords: ["privacy", "dati", "account", "legal"]
  },
  {
    id: "cookie",
    title: "Cookie policy",
    description: "Informazioni su cookie tecnici e servizi esterni.",
    to: "/cookie-policy",
    type: "Legal",
    keywords: ["cookie", "policy", "privacy", "browser"]
  },
  {
    id: "terms",
    title: "Termini, vendita e rimborsi",
    description: "Informazioni su acquisti, licenze, supporto e rimborsi.",
    to: "/terms",
    type: "Legal",
    keywords: ["termini", "vendita", "rimborsi", "rimborso", "supporto", "store"]
  },
  ...games.map(game => ({
    id: game.id,
    title: game.name,
    description: game.summary,
    to: game.route,
    type: "Gioco",
    keywords: [
      game.name,
      game.slug,
      game.status,
      game.platform,
      game.storeStatus,
      game.leaderboardStatus,
      "launcher",
      "store",
      "kyros"
    ]
  }))
];

export function normalizeSearchText(value = "") {
  const text = String(value).toLowerCase().trim();
  const asciiText =
    typeof text.normalize === "function"
      ? text.normalize("NFD").replace(/[\u0300-\u036f]/g, "")
      : text;

  return asciiText.replace(/[^a-z0-9\s/-]/g, " ").replace(/\s+/g, " ").trim();
}

function scoreSearchEntry(entry, normalizedQuery, queryTokens) {
  if (!normalizedQuery) {
    return 0;
  }

  const normalizedTitle = normalizeSearchText(entry.title);
  const normalizedDescription = normalizeSearchText(entry.description);
  const normalizedKeywords = (entry.keywords || []).map(keyword => normalizeSearchText(keyword));
  const searchBlob = `${normalizedTitle} ${normalizedDescription} ${normalizedKeywords.join(" ")}`.trim();

  let score = 0;

  if (normalizedTitle === normalizedQuery) {
    score += 140;
  } else if (normalizedTitle.startsWith(normalizedQuery)) {
    score += 110;
  } else if (normalizedTitle.includes(normalizedQuery)) {
    score += 90;
  }

  if (normalizedDescription.includes(normalizedQuery)) {
    score += 60;
  }

  if (searchBlob.includes(normalizedQuery)) {
    score += 35;
  }

  queryTokens.forEach(token => {
    if (!token) {
      return;
    }

    if (normalizedTitle.includes(token)) {
      score += 30;
    } else if (searchBlob.includes(token)) {
      score += 14;
    }
  });

  return score;
}

export function findSiteMatches(query, limit = 8) {
  const normalizedQuery = normalizeSearchText(query);
  if (!normalizedQuery || normalizedQuery.length < 2) {
    return [];
  }

  const queryTokens = normalizedQuery.split(" ").filter(Boolean);

  return siteSearchEntries
    .map(entry => ({ ...entry, score: scoreSearchEntry(entry, normalizedQuery, queryTokens) }))
    .filter(entry => entry.score > 0)
    .sort((a, b) => b.score - a.score || a.title.localeCompare(b.title, "it"))
    .slice(0, limit);
}
